import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function RestaurantFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cuisine, setCuisine] = useState("all");
  const [priceRange, setPriceRange] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const handleEditPost = (post) => {
    setSelectedRestaurant(null);
    setEditingPost(post);
  };
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
    setSelectedRestaurant(null);
  };

  const cuisines = [
    { id: "all", name: "Todas" },
    { id: "brazilian", name: "Brasileira" },
    { id: "italian", name: "Italiana" },
    { id: "japanese", name: "Japonesa" },
    { id: "mexican", name: "Mexicana" },
    { id: "chinese", name: "Chinesa" },
    { id: "american", name: "Americana" },
    { id: "arabian", name: "Árabe" },
  ];

  const priceRanges = [
    { id: "all", name: "Todos" },
    { id: "1", name: "$" },
    { id: "2", name: "$$" },
    { id: "3", name: "$$$" },
    { id: "4", name: "$$$$" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/restaurant?page=${pageNum}&limit=12`;
      if (cuisine !== "all") url += `&cuisine=${cuisine}`;
      if (priceRange !== "all") url += `&priceRange=${priceRange}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching restaurants:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [cuisine, priceRange]);

  const getPriceLabel = (range) => {
    return "$".repeat(parseInt(range) || 1);
  };

  if (loading && posts.length === 0) {
    return <div className="restaurant_feed_loading"><div className="restaurant_loader"></div><span>Carregando restaurantes...</span></div>;
  }

  return (
    <div className="restaurant_feed">
      <div className="restaurant_header">
        <h1>Restaurantes</h1>
        <p>Descubra os melhores lugares para comer</p>
      </div>

      <div className="restaurant_filters">
        <div className="restaurant_cuisine_filter">
          {cuisines.map((c) => (
            <button key={c.id} className={cuisine === c.id ? "active" : ""} onClick={() => setCuisine(c.id)}>
              {c.name}
            </button>
          ))}
        </div>
        <div className="restaurant_price_filter">
          {priceRanges.map((p) => (
            <button key={p.id} className={priceRange === p.id ? "active" : ""} onClick={() => setPriceRange(p.id)}>
              {p.name}
            </button>
          ))}
        </div>
      </div>

      {posts.length === 0 ? (
        <div className="restaurant_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"/>
          </svg>
          <h3>Nenhum restaurante encontrado</h3>
          <p>Seja o primeiro a recomendar!</p>
        </div>
      ) : (
        <div className="restaurant_grid">
          {posts.map((post) => (
            <div key={post._id} className="restaurant_card" onClick={() => setSelectedRestaurant(post)}>
              <div className="restaurant_image">
                <img src={post.restaurantData?.coverImage || post.images?.[0]?.url || post.images?.[0] || "/images/default-restaurant.png"} alt="" />
                {post.restaurantData?.isOpen !== false && (
                  <span className="restaurant_open_badge">Aberto</span>
                )}
                {post.restaurantData?.hasDelivery && (
                  <span className="restaurant_delivery_badge">Delivery</span>
                )}
              </div>
              <div className="restaurant_card_content">
                <div className="restaurant_card_header">
                  <h3>{post.restaurantData?.name || post.text}</h3>
                  {post.restaurantData?.rating && (
                    <span className="restaurant_rating">⭐ {post.restaurantData.rating.toFixed(1)}</span>
                  )}
                </div>
                <p className="restaurant_cuisine_type">
                  {cuisines.find(c => c.id === post.restaurantData?.cuisineType)?.name || post.restaurantData?.cuisineType}
                  {post.restaurantData?.priceRange && ` • ${getPriceLabel(post.restaurantData.priceRange)}`}
                </p>
                <p className="restaurant_address">{post.restaurantData?.address}</p>
                <div className="restaurant_footer">
                  <Link to={`/profile/${post.user.username}`} className="restaurant_recommender" onClick={(e) => e.stopPropagation()}>
                    <img src={post.user.picture} alt="" />
                    <span>{post.user.first_name}</span>
                  </Link>
                  <div onClick={(e) => e.stopPropagation()}>
                    <FeedPostMenu
                      post={post}
                      onEdit={handleEditPost}
                      onPostDeleted={handlePostDeleted}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="restaurant_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais restaurantes"}
          </button>
        </div>
      )}

      {selectedRestaurant && (
        <div className="restaurant_modal_overlay" onClick={() => setSelectedRestaurant(null)}>
          <div className="restaurant_modal" onClick={(e) => e.stopPropagation()}>
            <button className="restaurant_modal_close" onClick={() => setSelectedRestaurant(null)}>✕</button>
            <div className="restaurant_modal_header">
              <img src={selectedRestaurant.restaurantData?.coverImage || selectedRestaurant.images?.[0]} alt="" />
            </div>
            <div className="restaurant_modal_body">
              <div className="restaurant_modal_title">
                <h2>{selectedRestaurant.restaurantData?.name}</h2>
                {selectedRestaurant.restaurantData?.rating && (
                  <span className="restaurant_modal_rating">⭐ {selectedRestaurant.restaurantData.rating.toFixed(1)}</span>
                )}
              </div>
              <p className="restaurant_modal_type">
                {cuisines.find(c => c.id === selectedRestaurant.restaurantData?.cuisineType)?.name}
                {selectedRestaurant.restaurantData?.priceRange && ` • ${getPriceLabel(selectedRestaurant.restaurantData.priceRange)}`}
              </p>
              <p className="restaurant_modal_desc">{selectedRestaurant.restaurantData?.description || selectedRestaurant.text}</p>

              <div className="restaurant_modal_info">
                {selectedRestaurant.restaurantData?.address && (
                  <div className="restaurant_info_item">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                    </svg>
                    <span>{selectedRestaurant.restaurantData.address}</span>
                  </div>
                )}
                {selectedRestaurant.restaurantData?.phone && (
                  <div className="restaurant_info_item">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                    </svg>
                    <span>{selectedRestaurant.restaurantData.phone}</span>
                  </div>
                )}
                {selectedRestaurant.restaurantData?.openingHours && (
                  <div className="restaurant_info_item">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                    </svg>
                    <span>{selectedRestaurant.restaurantData.openingHours}</span>
                  </div>
                )}
              </div>

              <div className="restaurant_modal_tags">
                {selectedRestaurant.restaurantData?.hasDelivery && <span className="restaurant_tag">Delivery</span>}
                {selectedRestaurant.restaurantData?.hasReservation && <span className="restaurant_tag">Reservas</span>}
                {selectedRestaurant.restaurantData?.acceptsCard && <span className="restaurant_tag">Cartão</span>}
              </div>

              <div className="restaurant_modal_footer">
                <Link to={`/profile/${selectedRestaurant.user.username}`} className="restaurant_modal_recommender">
                  <img src={selectedRestaurant.user.picture} alt="" />
                  <span>Recomendado por {selectedRestaurant.user.first_name}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}
    </div>
  );
}
